/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceGroupDto } from '../../models/device-group-dto';

export interface DeviceGroupControllerFindAllByClientId$Params {
  clientWorkspaceId: string;
}

export function deviceGroupControllerFindAllByClientId(http: HttpClient, rootUrl: string, params: DeviceGroupControllerFindAllByClientId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DeviceGroupDto>>> {
  const rb = new RequestBuilder(rootUrl, deviceGroupControllerFindAllByClientId.PATH, 'get');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DeviceGroupDto>>;
    })
  );
}

deviceGroupControllerFindAllByClientId.PATH = '/api/device-group/all/{clientWorkspaceId}';
